import styled from "styled-components/macro";

export const Container = styled.div`
  width: 100%;

  .worldbuilding-card,
  .worldbuilding-card-footer {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: none;
    background: var(--simplified-sb-background);
    border-radius: 20px;

    .left-container {
      display: flex;
      align-items: center;
      gap: 8px;

      .chevron-wrapper {
        display: flex;
        align-items: center;
      }

      .collapse-chevron {
        cursor: pointer;
        width: 20px;
        height: 20px;
        transition: transform 0.2s ease;

        path {
          fill: var(--grey-2);
        }
      }

      .rotated-chevron {
        transform: rotate(-90deg);
      }
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 16px 16px 0;
      width: calc(100% - 30px);
      margin: 0px;
      .tertiary {
        svg {
          width: 18px;
          height: 18px;
          margin-right: 4px;
          path {
            fill: var(--grey-1);
          }
        }
      }
      .primary {
        display: flex;
        flex-direction: row;
        gap: 4px;
        padding: 7px 12px 7px 7px !important;
        border-radius: 10px !important;
        margin-top: 0px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        svg {
          path {
            fill: var(--cta-text-color);
          }
        }
      }
      .title-lockup {
        display: flex;
        flex-direction: row;
        align-items: center;

        svg {
          width: 28px;
          height: 28px;
          margin-right: 2px;
          path {
            fill: var(--grey-0);
          }
        }
      }

      .left-side {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        flex-shrink: 1; //allow left side to reflow before the right

        h2 {
          margin-bottom: 0px !important;
          font-weight: 500;
          font-size: 20px !important;
        }
      }
      .right-side {
        display: flex;
        align-items: center;
        right: 0px;
        gap: 10px;
        flex-shrink: 0; //don't let the right side reflow
        z-index: auto;
        position: relative;

        .three-dots {
          margin-right: 2px;
          padding: unset !important;
        }
      }
    }
  }

  .about {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--grey-1);
    font-weight: 500;
    .show-suggestions-button {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 32px);
    padding: 14px 16px 16px 16px;
    border-top: 1.5px solid var(--menu-color-active);
    background-color: var(--menu-color);
    border-radius: 0px 0px 20px 20px;
    p {
      font-size: 18px;
      color: var(--grey-0);
    }

    .create-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      svg {
        width: 18px;
        height: 18px;
        path {
          fill: var(--grey-0);
        }
      }
    }
    .create-buttons {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      gap: 10px;
      .text-button-inner {
        border: 1px solid var(--primary-cta-high-contrast) !important;
        border-radius: 10px;
        margin-top: 0px !important;
        color: var(--primary-cta-high-contrast) !important;
        &:hover {
          background-color: var(--menu-color-primary-cta-overlay-hover);
        }
        &:active {
          background-color: var(--menu-color-primary-cta-overlay-active);
        }
      }
      p {
        font-size: 16px;
        color: var(--primary-cta-high-contrast);
        font-weight: 500;
      }
    }
  }

  .guidance {
    position: absolute;
    right: 16px;
    z-index: 30000;
    border-radius: 20px;
    background-color: var(--menu-color);
    margin-top: 10px;
    padding: 20px 18px;
    box-shadow: var(--drop-shadow-15-25);

    &.section-header-position {
      right: 0;
      top: 45px;
    }

    .guidanceRoleSelect {
      width: 150px;
      margin-bottom: 12px;
    }

    textarea {
      width: 350px;
      min-height: 72px;
      padding: 6px 10px;
      border-radius: 10px;
      resize: none;
      font-size: 16px;
      box-sizing: border-box;
      border: 2px solid var(--grey-2);

      &:focus {
        border-color: var(--primary-cta);
      }
    }
    .guidanceButtons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      button {
        margin-top: 0px !important;
      }
    }
    .randomCharacterButton {
      border: none !important;
      background: none !important;
      color: var(--grey-0) !important;
      display: flex;
      align-items: center;
      .text-button-inner {
        padding-left: 8px;
      }
      svg {
        path {
          fill: var(--grey-0);
        }
      }
    }
    .goButton {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;

      padding: 9px 14px !important;
      border-radius: 10px !important;

      .keyboard-shortcut {
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
      .keyboard-shortcut-container {
        display: flex;
        align-items: center;
        gap: 3px;
      }
    }
  }

  .worldbuilding-card-footer {
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;

    .header {
      padding: 0;
      width: 100%;

      .right-side {
        right: 0;
      }
    }
  }

  .hoverable-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    button {
      padding: 7px 12px 7px 7px !important;
    }
  }
`;
